"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetMetricUnitTypeEnum = void 0;
var StatsWidgetMetricUnitTypeEnum;
(function (StatsWidgetMetricUnitTypeEnum) {
    StatsWidgetMetricUnitTypeEnum["Number"] = "NUMBER";
    StatsWidgetMetricUnitTypeEnum["String"] = "STRING";
    StatsWidgetMetricUnitTypeEnum["Percent"] = "PERCENT";
    StatsWidgetMetricUnitTypeEnum["Second"] = "SECOND";
    StatsWidgetMetricUnitTypeEnum["Count"] = "COUNT";
    StatsWidgetMetricUnitTypeEnum["DateTime"] = "DATETIME";
    StatsWidgetMetricUnitTypeEnum["Countdown"] = "COUNTDOWN";
    StatsWidgetMetricUnitTypeEnum["Boolean"] = "BOOLEAN";
})(StatsWidgetMetricUnitTypeEnum = exports.StatsWidgetMetricUnitTypeEnum || (exports.StatsWidgetMetricUnitTypeEnum = {}));
